import React, { Component } from 'react';
import { notification } from 'antd';

import apiService from './../modules/Agencies/apiService';
import { t } from '../system/i18n';

const withAgencies = WrappedComponent => {
    return class extends Component {
        state = {
            agencies: [],
            loadingAgencies: false
        };

        getAgencies = async filter => {
            this.setState({
                loadingAgencies: true
            });
    
            try {
                const response = await apiService.getAgencySuggest(filter);
    
                this.setState({
                    agencies: response.data.agencies
                });
            } catch (error) {
                notification.error({
                    message: t('message.server_error')
                });
            }
    
            this.setState({
                loadingAgencies: false
            });
        };

        render() {
            const { agencies, loadingAgencies, pagination } = this.state;

            return (
                <WrappedComponent
                    {...this.props}
                    agencies={agencies}
                    loadingAgencies={loadingAgencies}
                    pagination={pagination}
                    getAgencies={this.getAgencies}
                />
            );
        }
    };
};

export default withAgencies;
